import { statisticActions } from "../../actionTypes";
import produce from "immer";

const initialState = {
	stats: {
		months: {},
		days: {},
		hours: {},
	},
	fetching: false,
	fetched: false,
	error: null,
};

const Reducer = (state = initialState, action) =>
	produce(state, draft => {
		switch (action.type) {
			case statisticActions.FETCH_STATS_ID: {
				draft.fetching = true;
				break;
			}

			case statisticActions.FETCH_STATS_ID_FULFILED: {
				draft.fetching = false;
				draft.fetched = true;
				draft.stats[action.payload.period] = action.payload.res;
				break;
			}

			case statisticActions.FETCH_STATS_ID_REJECTED: {
				draft.fetching = false;
				draft.error = action.payload;
				break;
			}
			default:
				return draft;
		}
	});

export default Reducer;
